@for (option of options$ | async; track option) {
  <button
    ngbDropdownItem [ngClass]="{ 'active': option.value }"
    [disabled]="disabled" (click)="toggleOption(option.key)">
    {{ shippingStatusLabel(option.key, isInternalUser$ | async) }}
  </button>
}
<div class="dropdown-divider"></div>
<button ngbDropdownItem class="text-end" [disabled]="disabled" (click)="clear()">
  <i class="fas fa-times"></i>
  Clear
</button>
